import { Component, Input, OnInit } from '@angular/core';
import { ThemeService } from 'src/app/services/theme.service';

@Component({
  selector: 'app-logo-name-color',
  templateUrl: './logo-name-color.component.html',
  styleUrls: ['./logo-name-color.component.scss']
})
export class LogoNameColorComponent implements OnInit {
  @Input() height: string = "1rem";
  logoSrc = 1;

  constructor(private themeService: ThemeService) {}
  
    ngOnInit() {
      this.setLogoByTheme(this.themeService.getCurrentTheme());
    }
  
    private setLogoByTheme(theme: string | null) {
      switch (theme) {
        case 'blue-theme':
          this.logoSrc = 1;
          break;
        case 'green-theme': //Extracciones
          this.logoSrc = 2;
          break;
        case 'yellow-theme':  //Alfa y Omega
          this.logoSrc = 3;
          break;
        case 'food-theme':  // Alimentos
          this.logoSrc = 4;
          break;
        default:
          this.logoSrc = 1;
      }
    }
}
